import { useState } from 'react';

export const useToggle = (defaultValue = false) => {
  const [state, setState] = useState(defaultValue)
  const toggle = () => setState(prevState => !prevState)
  return [state, toggle]
}
